import { useSelector } from 'react-redux';
import type { RoleAssumptionState, StateTree } from '../types';

export const useRoleAssumptionSelector = (): RoleAssumptionState => {
    const state: RoleAssumptionState = useSelector((state: StateTree) => state.roleAssumption);
    return state;
};
